import { useEffect, useMemo, useState } from "react";
import { withNamespaces } from "react-i18next";
import TableFilter from "src/components/TableFilter";

const FilteringComponent = ({
    t,
    onChange,
    fetchOwnersQuery,
    tab
}) => {
    const [ tableFilters, setTableFilters ] = useState({
        status: null,
        flag: null,
        owner: null,
        incomplete_risk_assessment: null,
        service: undefined
    });

    const statuses = useMemo(() => {
        return [
            {
                id: 'NEW',
                title: t('New')
            },
            {
                id: 'IN_PROGRESS',
                title: t('In Progress')
            },
            {
                id: 'OPEN',
                title: t('Open')
            },
            {
                id: 'APPROVED',
                title: t('Approved')
            },
            {
                id: 'ASSIGNED',
                title: t('Assigned')
            },
            {
                id: 'DELETED',
                title: t('Deleted')
            }
        ]
    }, [ t ]);

    const flags = useMemo(() => {
        return [
            { 
                id: true, 
                title: t("Flag On") 
            },
            { 
                id: false, 
                title: t("Flag Off") 
            }
          ];
    }, [ t ])

    const riskAssessmentStatusValues = useMemo(() => {
        return [
            {
                id: 'true',
                title: t('Incomplete')
            },
            {
                id: 'false',
                title: t('Complete')
            }
        ]
    }, [ t ]);

    const tableFilterTabs = useMemo(() => {
        const tabs = []

        if(tab !== 'deletion-protocol'){
            tabs.push({
                type: 'radio_list',
                name: 'status',
                title: 'Status',
                icon: <i className="ri-toggle-line" />,
                isLoading: false,
                defaultValue: tableFilters?.status,
                data: statuses || [],
                searchInListOption: {
                    enabled: true,
                    remote: false
                },
                formatter: (item) => {
                    return item.title
                }
            })
        }

        return [
            ...tabs,
            {
                type: 'radio_list',
                name: 'flag',
                title: 'Flag',
                icon: <i className="ri-flag-line" />,
                isLoading: false,
                defaultValue: tableFilters?.flag,
                data: flags || [],
                searchInListOption: {
                    enabled: true,
                    remote: false
                },
                formatter: (item) => {
                    return item.title
                }
            },
            {
                type: 'radio_list',
                name: 'owner',
                title: 'Owner',
                icon: <i className="ri-user-line" />,
                isLoading: fetchOwnersQuery.isFetching,
                defaultValue: tableFilters?.owner,
                data: fetchOwnersQuery.data || [],
                searchInListOption: {
                    enabled: true,
                    remote: false
                },
                formatter: (item) => {
                    return item.first_name + " " + item.last_name
                }
            },
            {
                type: 'radio_list',
                name: 'incomplete_risk_assessment',
                title: 'Risk Assessment Status',
                icon: <i className="ri-checkbox-multiple-line" />,
                isLoading: false,
                defaultValue: tableFilters?.incomplete_risk_assessment,
                data: riskAssessmentStatusValues,
                searchInListOption: {
                    enabled: false,
                    remote: false
                },
                formatter: (item) => {
                    return item.title
                }
            },
            {
                type: 'search_textbox',
                name: 'service',
                title: 'Search by service name',
                icon: <i className="ri-terminal-box-line" />,
                defaultValue: tableFilters?.service,
                options: {
                    placeholder: 'Search by service name',
                    typingDelay: 750
                },
                displayIndependently: true,
                onFilterChange: (value) => {
                    setTableFilters((currentState) => ({...currentState, service: value}))
                }
            }
        ]
    }, [
        tableFilters,
        statuses,
        flags,
        riskAssessmentStatusValues,
        tab,
        fetchOwnersQuery.isFetching,
        fetchOwnersQuery.data
    ]);

    const onTableFilterOkButtonClicked = (filters, independentTabsData) => {
        if (filters) {
            const result = {}

            if ('status' in filters) {
                result.status = filters.status !== 'all' ? filters.status : undefined
            }

            if ('flag' in filters) {
                result.flag = filters.flag !== 'all' ? filters.flag : undefined
            }

            if ('owner' in filters) {
                result.owner = filters.owner !== 'all' ? filters.owner : undefined
            }

            if ('incomplete_risk_assessment' in filters) {
                result.incomplete_risk_assessment = filters.incomplete_risk_assessment !== 'all' ? filters.incomplete_risk_assessment : undefined
            }

            setTableFilters({
                ...tableFilters,
                ...result
            })
        } else {
            setTableFilters({
                service: independentTabsData?.service || undefined,
                status: null,
                flag: null,
                owner: null,
                incomplete_risk_assessment: null
            })
        }
    }

    useEffect(() => {
        onChange && onChange(tableFilters)
    }, [ 
        tableFilters,
        onChange
    ]);

    return (
        <TableFilter
            className="me-2 softwares-filter"
            defaultActiveTab='status'
            tabs={tableFilterTabs}
            onOkButtonClicked={
                onTableFilterOkButtonClicked
            }
        />
    )
}

export default withNamespaces()(FilteringComponent);
